import { yupResolver } from '@hookform/resolvers/yup';
import { Toast } from 'primereact/toast';
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Button, Col, Container, Form, InputGroup, Navbar, Row, Table } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
import { Controller, useForm } from 'react-hook-form';
import { FaPencilAlt, FaPlus, FaSearch, FaTrashAlt } from "react-icons/fa";
import { HiArrowLeft } from 'react-icons/hi';
import Loader from "react-js-loader";
import { useMediaQuery } from 'react-responsive';
import { Link, useNavigate, useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import Header from '../../Layout/Header';
import SidebarMenu from "../../Layout/SidebarMenu";
import BsAlert from "../../Utils/BsAlert";
import { getEndpointUrl } from "../../Utils/Common";
import CreatePelanggan from "../Customer/CreatePelanggan";
import ModalSelectCustomer from "../Customer/ModalSelectCustomer";
import Error404 from '../Error404';
import CreateItem from "./CreateItem";
import ModalDeleteCreateItem from './ModalDeleteCreateItem';
import UpdateItem from './UpdateItem';

/**
 * Normalisasi nilai model item.
 * - Item lokal (belum tersimpan) memakai key `model`
 * - Item dari backend memakai key `modelName` (nama kolom di DB)
 */
const getItemModel = (item) => {
    if (!item) return '';
    return item.model || item.modelName || '';
};

const UpdateOffer = () => {
    const [error404, setError404] = useState(false);

    const toast = useRef(null);

    const [isLoading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const params = useParams();
    const [offer, setOffer] = useState([]);
    const [customer, setCustomer] = useState([]);

    const [modalSelectCustomer, setModalSelectCustomer] = useState(false);

    const [modalCretaeCustomer, setModalCreateCustomer] = useState(false);

    const fetchDataCustomer = useCallback(async (customer_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/customer/${customer_id !== undefined ? customer_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setCustomer(json.results);
            }

            setLoading(false);
        });
    }, []);

    const fetchDataOffer = useCallback(async (offer_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/offer/${offer_id !== undefined ? offer_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setOffer(json.results);

                let defaultValues = {};
                defaultValues.customer_id = json.results.customer_id;
                defaultValues.customerName = json.results.customerName;
                defaultValues.amount = json.results.price;
                defaultValues.description = json.results.description;
                reset({ ...defaultValues });
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchDataOffer(params.offer_id);
    }, [params, fetchDataOffer]);

    // Muat detail pelanggan sesuai offer yang sedang diedit
    useEffect(() => {
        if (offer && offer.customer_id) {
            fetchDataCustomer(offer.customer_id);
        }
    }, [offer && offer.customer_id, fetchDataCustomer]);

    const validationSchema = Yup.object().shape({
        customer_id: Yup.number().nullable().typeError("Field berupa angka").required('Field harus diisi'),
        amount: Yup.number().nullable().typeError("Field berupa angka").required('Field harus diisi'),
        description: Yup.string().required('Field harus diisi')
    });

    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const [items, setItems] = useState(JSON.parse(localStorage.getItem('offerItems')) || []);
    const [itemSelected, setItemSelected] = useState([]);
    const [modalCreateItem, setModalCreateItem] = useState(false);
    const [modalUpdateItem, setModalUpdateItem] = useState(false);
    const [modalDeleteCreateItem, setModalDeleteCreateItem] = useState(false);

    useEffect(() => {
        // Jangan timpa data offer sebelum detail pelanggan selesai dimuat
        if (!customer || !customer.id) return;

        setOffer((prevState) => {
            return ({
                ...prevState,
                customerName: customer.name,
                customerPhone: customer.phone,
                customerEmail: customer.email,
                customerAddress: customer.address,
                customer_id: customer.id
            });
        });
    }, [customer]);

    useEffect(() => {
        localStorage.setItem("offerItems", JSON.stringify(items));
    }, [items]);

    const onCallbackSelectCustomer = useCallback((e) => {
        setCustomer(e);
    }, []);

    const onCallbackOnCreateItem = useCallback((e) => {
        setItems(prevState => [...prevState, e]);
    }, []);

    const onCallbackOnUpdateItem = useCallback((e) => {
        if (Number.isInteger(e.id)) {
            setOffer((prevState) => {
                return ({
                    ...prevState,
                    items: prevState.items.map(item => {
                        if (item.id === e.id) {
                            return {
                                ...item,
                                contactName: e.contactName,
                                contactPhone: e.contactPhone,
                                brandName: e.brandName,
                                type: e.type,
                                model: e.model,
                                modelName: e.model,
                                builtYear: e.builtYear,
                                policeNumber: e.policeNumber,
                                color: e.color,
                                tax: e.tax,
                                odometer: e.odometer,
                                transmission: e.transmission,
                                manualBook: e.manualBook,
                                serviceRecords: e.serviceRecords,
                                location: e.location,
                                user_id: e.user_id
                            }
                        }

                        return item;
                    })

                });
            });
        } else {
            setItems(prevState => prevState.map(x => {
                if (x.id === e.id) {
                    return {
                        ...x,
                        contactName: e.contactName,
                        contactPhone: e.contactPhone,
                        brandName: e.brandName,
                        type: e.type,
                        model: e.model,
                        builtYear: e.builtYear,
                        policeNumber: e.policeNumber,
                        color: e.color,
                        tax: e.tax,
                        odometer: e.odometer,
                        transmission: e.transmission,
                        manualBook: e.manualBook,
                        serviceRecords: e.serviceRecords,
                        location: e.location,
                        user_id: e.user_id
                    }
                }
                return x;
            }));
        }
    }, []);

    const onCallbackDeleteItem = useCallback((e) => {
        if (Number.isInteger(e.id)) {
            setOffer((prevState) => {
                return ({
                    ...prevState,
                    items: prevState.items.filter(item => item.id !== e.id)
                });
            });
        } else {
            setItems(prevState => prevState.filter(item => item.id !== e.id));
        }
    }, []);

    const onSubmit = async (data) => {
        setSaveLoading(true);

        fetch(getEndpointUrl() + `/offer/${params.offer_id}`, {
            method: "PUT",
            body: new URLSearchParams({
                customer_id: (offer && offer.customer_id) || data.customer_id,
                price: data.amount,
                description: data.description,
                user_id: userLogin.id,
                items: JSON.stringify(items)
            }),
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setSaveLoading(false);

            if (json.status === 'ok') {
                toast.current.show({ severity: 'success', summary: 'Berhasil', detail: "Yeay, Perubahan berhasil disimpan." });
                setOffer(json.results.data);
                setItems([]);
                localStorage.removeItem('offerItems');
            } else {
                toast.current.show({ severity: 'warning', summary: 'Berhasil', detail: json.message });
            }
        }).catch(error => {
            setSaveLoading(false);
        });
    };

    return error404 ? <Error404 /> : (
        <>
            <Helmet>
                <title>Update Penawaran</title>
            </Helmet>
            <Toast ref={toast} />
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Update Penawaran</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline">
                <Header />
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <Container className="mt-3 mb-5">
                <Row>
                    <Col md={7}>
                        <Form onSubmit={handleSubmit(onSubmit)} key={'update-offer'}>
                            <Row className="d-none d-sm-inline">
                                <Col md={12}>
                                    <strong>Ubah Penawaran</strong>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <BsAlert />
                                </Col>
                            </Row>
                            <Row className="mt-3 mb-3">
                                <Col md={10} sm={12}>
                                    <Form.Label>Penawaran kepada :</Form.Label>
                                    <InputGroup>
                                        <Controller
                                            render={({ field }) => (
                                                <Form.Control {...field}
                                                    type="number"
                                                    placeholder="Silahkan pilih pelanggan..."
                                                    readOnly
                                                    disabled
                                                    isInvalid={errors.customer_id ? true : false} />
                                            )}
                                            control={control}
                                            defaultValue={customer.id}
                                            name="customer_id"
                                        />
                                        <Button variant="outline-secondary" onClick={(e) => setModalSelectCustomer(true)}><FaSearch /> Cari</Button>
                                        <Button variant="outline-secondary" onClick={(e) => setModalCreateCustomer(true)}><FaPlus /> Tambahkan</Button>
                                    </InputGroup>
                                    <Form.Text className="text-muted fs-13 clearfix">{errors.customer_id?.message}</Form.Text>
                                    <CreatePelanggan onCallback={onCallbackSelectCustomer} show={modalCretaeCustomer} close={(e) => setModalCreateCustomer(false)} />
                                    <ModalSelectCustomer onCallback={onCallbackSelectCustomer} show={modalSelectCustomer} close={(e) => setModalSelectCustomer(false)} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Table className="mt-2 fs-13">
                                        <tbody>
                                            <tr>
                                                <td className="text-muted">Nama</td>
                                                <td className="text-center">:</td>
                                                <td className="fw-bold">
                                                    {isLoading ?
                                                        <div className="loader-text">
                                                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                        </div> :
                                                        offer.customerName
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Email</td>
                                                <td className="text-center">:</td>
                                                <td className="fw-medium">
                                                    {isLoading ?
                                                        <div className="loader-text">
                                                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                        </div> :
                                                        offer.customerEmail
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">No Handphone</td>
                                                <td className="text-center">:</td>
                                                <td className="fw-medium">
                                                    {isLoading ?
                                                        <div className="loader-text">
                                                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                        </div> :
                                                        offer.customerPhone
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Alamat</td>
                                                <td className="text-center">:</td>
                                                <td className="fw-medium">
                                                    {isLoading ?
                                                        <div className="loader-text">
                                                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                        </div> :
                                                        offer.customerAddress
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Total Penawaran :</Form.Label>
                                        <Form.Control type="number" {...register("amount")} isInvalid={errors.amount ? true : false} disabled={saveLoading || isLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.amount?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Deskripsi :</Form.Label>
                                        <Form.Control type="text" as={'textarea'} rows={5}  {...register("description")} isInvalid={errors.description ? true : false} disabled={saveLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.description?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3 mb-5">
                                <Col md={12} className="d-flex justify-content-end">
                                    <Link to={"#"} onClick={() => navigate(-1)} title="Batal" className="btn btn-secondary me-3">Batal</Link>
                                    <Button type="submit" variant="primary" disabled={saveLoading}>{saveLoading ? "Mengirim data..." : "Simpan Perubahan"}</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col md={5}>
                        <div className="d-flex justify-content-between">
                            <strong className="mt-2">Item Penawaran</strong>
                            <Button variant="outline-secondary" onClick={(e) => setModalCreateItem(true)}><FaPlus /> Tambahkan Item</Button>
                            <CreateItem onCallback={onCallbackOnCreateItem} show={modalCreateItem} close={(e) => setModalCreateItem(false)} />
                            <UpdateItem onCallback={onCallbackOnUpdateItem} row={itemSelected} show={modalUpdateItem} close={(e) => setModalUpdateItem(false)} />
                            <ModalDeleteCreateItem onCallback={onCallbackDeleteItem} row={itemSelected} show={modalDeleteCreateItem} close={(e) => setModalDeleteCreateItem(false)} />
                        </div>
                        <div className="border mt-4 px-3 py-3 rounded-3 minh-480">
                            {items.length == 0 && !isLoading && offer && offer.items.length == 0 &&
                                <Table className="mt-2 fs-13">
                                    <tbody>
                                        <tr>
                                            <td className="text-muted" width={150}>Merk Mobil :</td>
                                            <td className="fw-bold"></td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted">Tipe :</td>
                                            <td className="fw-medium"></td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted">Tahun :</td>
                                            <td className="fw-medium"></td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted">No Polisi :</td>
                                            <td className="fw-medium"></td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted">Lokasi :</td>
                                            <td className="fw-medium"></td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted">Petugas Inspeksi :</td>
                                            <td className="fw-medium"></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            }
                            {items.map((item, key) =>
                                <>
                                    <div className="d-flex justify-content-between">
                                        <strong className="fs-13">Target Inspeksi <small className="text-success">[Baru]</small> #{++key}</strong>
                                        <div className="">
                                            <Button variant="outline-secondary" size="sm" className="pt-1" onClick={(e) => {
                                                setModalUpdateItem(true);
                                                setItemSelected(item);
                                            }}><FaPencilAlt /> Ubah</Button>
                                            <Button variant="outline-danger" size="sm" className="pt-1 ms-2" onClick={(e) => {
                                                setModalDeleteCreateItem(true);
                                                setItemSelected(item);
                                            }}><FaTrashAlt /> Ubah</Button>
                                        </div>
                                    </div>
                                    <Table className="mt-2 fs-13">
                                        <tbody>
                                            <tr>
                                                <td className="text-muted" width={150}>Merk Mobil :</td>
                                                <td className="fw-bold">{item.brandName}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Tipe :</td>
                                                <td className="fw-medium">{item.type}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Model :</td>
                                                <td className="fw-medium">{getItemModel(item)}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Tahun :</td>
                                                <td className="fw-medium">{item.builtYear}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">No Polisi :</td>
                                                <td className="fw-medium">{item.policeNumber}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Lokasi :</td>
                                                <td className="fw-medium">{item.location}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </>
                            )}
                            {!isLoading && offer && offer.items.map((item, key) =>
                                <>
                                    <div className="d-flex justify-content-between">
                                        <strong className="fs-13">Target Inspeksi #{++key}</strong>
                                        <div className="">
                                            <Button variant="outline-secondary" size="sm" className="pt-1" onClick={(e) => {
                                                setModalUpdateItem(true);
                                                setItemSelected(item);
                                            }}><FaPencilAlt /> Ubah</Button>
                                            <Button variant="outline-danger" size="sm" className="pt-1 ms-2" onClick={(e) => {
                                                setModalDeleteCreateItem(true);
                                                setItemSelected(item);
                                            }}><FaTrashAlt /> Ubah</Button>
                                        </div>
                                    </div>
                                    <Table className="mt-2 fs-13">
                                        <tbody>
                                            <tr>
                                                <td className="text-muted" width={150}>Merk Mobil :</td>
                                                <td className="fw-bold">{item.brandName}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Tipe :</td>
                                                <td className="fw-medium">{item.type}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Model :</td>
                                                <td className="fw-medium">{getItemModel(item)}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Tahun :</td>
                                                <td className="fw-medium">{item.builtYear}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">No Polisi :</td>
                                                <td className="fw-medium">{item.policeNumber}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Transmission :</td>
                                                <td className="fw-medium">{item.transmission}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Warna :</td>
                                                <td className="fw-medium">{item.color}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Pajak :</td>
                                                <td className="fw-medium">{item.tax}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Buku Servis :</td>
                                                <td className="fw-medium">{item.serviceRecords}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Buku Manual :</td>
                                                <td className="fw-medium">{item.manualBook}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Lokasi :</td>
                                                <td className="fw-medium">{item.location}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>

        </>
    );
}

export default UpdateOffer;